// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f59bb78c","513":"bd99cdd4","703":"3a2127ed"}[chunkId] + ".chunk.js";
};